import CheckIcon from "@mui/icons-material/Check";
import { Button } from "@mui/material";
import { Spin } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import PsModalWindow from "../../../components/PsModalWindow";
import PsContext from "../../../context";
import { useDialog } from "../../../context/DialogContext";
import { _LIST_MODULES } from "../../../models/modulesModel";
import {
  _LIST_ROLE_AND_PERMISSIONS,
  _UPDATE_ROLE_AND_ACCESS_PERMISSIONS,
} from "../../../models/rbacModel";
import { groupByMultiple } from "../../../utils";

const UserPermissionModalComponent = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [dataList, setDataList] = useState([]);

  const [roleAccess, setRoleAccess] = useState([]);

  const { openDialog } = useDialog();

  const actionList = [
    "action_create",
    "action_list",
    "action_update",
    "action_delete",
    "action_print",
    "action_export",
  ];

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    _LIST_MODULES().then((res) => {
      if (res.status == "1") {
        let d = groupByMultiple(res.data, function (obj) {
          return [obj.module_title];
        });
        setDataList(d);
      } else {
        setDataList([]);
      }
      setLoader(false);
    });
    setLoader(true);
    _LIST_ROLE_AND_PERMISSIONS({ role_id: props.dataSource.id }).then((res) => {
      if (res.status == "1") {
        setRoleAccess(res.data);
      }
      setLoader(false);
    });
  };

  const selectAll = (items, action, e) => {
    let ra = [...roleAccess];
    if (action == false) {
      actionList.map((actionL, a) => {
        if (items[actionL] == "1") {
          let index = ra.findIndex(
            (obj) => obj.module_uid == items.id && obj.action_name == actionL
          );

          if (index > -1) {
            ra[index]["status"] = e === false ? "0" : "1";

            //if (props.userPermission) updateUserAccess(item, actionL, "deny");

            setRoleAccess(ra);
          } else if (e === true) {
            let m = dataList.find((obj) => obj.role_id == items.role_id);
            if (m) {
              ra.push({
                module_uid: items.id,
                action_name: actionL,
                status: 1,
              });
            }

            //if (props.userPermission)
            //updateUserAccess(item, actionL, "allow");
          }
        }
      });
    } else {
      items.map((item) => {
        //updateRoleAccess(item, action, e);

        let index = ra.findIndex(
          (obj) => obj.module_uid == item.id && obj.action_name == action
        );

        if (index > -1) {
          if (ra[index]["status"] == "0") ra[index]["status"] = 1;
          else ra[index]["status"] = 0;

          if (props.userPermission) updateUserAccess(item, action, "deny");

          setRoleAccess(ra);
        } else {
          let m = dataList.find((obj) => obj.role_id == item.role_id);
          if (m) {
            ra.push({
              module_uid: item.id,
              action_name: action,
              status: 1,
            });
          }

          if (props.userPermission) updateUserAccess(item, action, "allow");
        }
      });
    }

    setRoleAccess(ra);
  };

  const updateUserAccess = (item, fieldName, type) => {};

  const rolesUnderGroup = (items) => {
    return (
      <tr>
        <td colSpan={10}>
          <table className="table table-sm table-bordered bg-white">
            <thead>
              <tr className="fs-12">
                <th>{items[0].module_title}</th>
                <th></th>
                <th></th>
                <th align="center" className="text-center">
                  {!props.userPermission && (
                    <Form.Check
                      type="checkbox"
                      size="sm"
                      onChange={(e) => selectAll(items, "action_create", e)}
                    />
                  )}
                </th>
                <th align="center" className="text-center">
                  {!props.userPermission && (
                    <Form.Check
                      type="checkbox"
                      size="sm"
                      onChange={(e) => selectAll(items, "action_list", e)}
                    />
                  )}
                </th>
                <th align="center" className="text-center">
                  {!props.userPermission && (
                    <Form.Check
                      type="checkbox"
                      size="sm"
                      onChange={(e) => selectAll(items, "action_update", e)}
                    />
                  )}
                </th>
                <th align="center" className="text-center">
                  {!props.userPermission && (
                    <Form.Check
                      type="checkbox"
                      size="sm"
                      onChange={(e) => selectAll(items, "action_delete", e)}
                    />
                  )}
                </th>
                <th align="center" className="text-center">
                  {!props.userPermission && (
                    <Form.Check
                      type="checkbox"
                      size="sm"
                      onChange={(e) => selectAll(items, "action_print", e)}
                    />
                  )}
                </th>
                <th align="center" className="text-center">
                  {!props.userPermission && (
                    <Form.Check
                      type="checkbox"
                      size="sm"
                      onChange={(e) => selectAll(items, "action_export", e)}
                    />
                  )}
                </th>
              </tr>
            </thead>
            <tbody>{rolesList(items)}</tbody>
          </table>
        </td>
      </tr>
    );
  };

  const rolesList = (items) => {
    return items.map((item, i) => {
      return (
        <tr key={i} className="fs-12">
          <td>
            <span className="fw-bold">{item.module_description}</span>
            <br />
            <i>{item.module_name}</i>
          </td>
          <td align="center" width="50">
            {!props.userPermission && (
              <Form.Check
                type="checkbox"
                checked={false}
                size="sm"
                onChange={(e) => selectAll(item, false, true)}
              />
            )}
          </td>
          <td align="center" width="50">
            {!props.userPermission && (
              <Form.Check
                type="checkbox"
                size="sm"
                checked={false}
                onChange={(e) => selectAll(item, false, false)}
              />
            )}
          </td>
          <td width="50" align="center">
            {checkField(item, "action_create")}
          </td>
          <td width="50" align="center">
            {checkField(item, "action_list")}
          </td>
          <td width="50" align="center">
            {checkField(item, "action_update")}
          </td>
          <td width="50" align="center">
            {checkField(item, "action_delete")}
          </td>
          <td width="50" align="center">
            {checkField(item, "action_print")}
          </td>
          <td width="50" align="center">
            {checkField(item, "action_export")}
          </td>
        </tr>
      );
    });
  };

  const updateRoleAccess = (item, fieldName, e) => {
    //let v = e.target.checked ? '1' : '0';
    let ra = [...roleAccess];
    let index = ra.findIndex(
      (obj) => obj.module_uid == item.id && obj.action_name == fieldName
    );

    if (index > -1) {
      if (ra[index]["status"] == "0") ra[index]["status"] = 1;
      else ra[index]["status"] = 0;

      if (props.userPermission) updateUserAccess(item, fieldName, "deny");

      setRoleAccess(ra);
    } else {
      let m = dataList.find((obj) => obj.role_id == item.role_id);
      if (m) {
        ra.push({
          module_uid: item.id,
          action_name: fieldName,
          status: 1,
        });
      }

      if (props.userPermission) updateUserAccess(item, fieldName, "allow");

      setRoleAccess(ra);
    }
  };

  const checkField = (item, fieldName) => {
    return item[fieldName] == "1" ? (
      <input
        type="checkbox"
        checked={checkAccessEnabled(item, fieldName)}
        onChange={(e) => updateRoleAccess(item, fieldName, e)}
      />
    ) : (
      ""
    );
  };

  const checkAccessEnabled = (item, fieldName) => {
    let ra = [...roleAccess];
    let v = ra.find(
      (obj) => obj.module_uid == item.id && obj.action_name == fieldName
    );
    return v && v.status == "1" ? true : false;
  };

  const field = (fieldName) => props.dataSource[fieldName] || "";

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    setLoader(true);
    _UPDATE_ROLE_AND_ACCESS_PERMISSIONS({
      role_id: props.dataSource.id,
      permissions: JSON.stringify(roleAccess),
    }).then((res) => {
      if (res.status == "1") {
        context.setAlertMsg(res.message || "Updated");
        if (props.onSuccess) props.onSuccess();
      } else {
        openDialog({
          title: "Error",
          message: res.message || "Error on Update",
        });
      }
      setLoader(false);
    });
  };

  return (
    <>
      <Spin spinning={loader}>
        <Form
          noValidate
          validated={validated}
          action=""
          method="post"
          onSubmit={handleFormSubmit}
        >
          <input type="hidden" name="role_id" value={field("id")} />

          <Row className="mb-3">
            <Col md={3}>
              <label>
                Name of the Role <span className="text-danger"></span>
              </label>
            </Col>
            <Col md={9}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="role_name"
                defaultValue={field("role_name")}
                readOnly
                required
              />
            </Col>
          </Row>

          <table className="table table-sm table-bordered bg-light">
            <thead
              className="bg-light "
              style={{ position: "sticky", top: "5px" }}
            >
              <tr className="fs-12">
                <th>Module</th>
                <th width="50" align="center" className="text-center fs-11">
                  Select
                </th>
                <th width="50" align="center" className="text-center fs-11">
                  De-Sel.
                </th>
                <th width="50" align="center" className="text-center fs-11">
                  Create
                </th>
                <th width="50" align="center" className="text-center fs-11">
                  List
                </th>
                <th width="50" align="center" className="text-center fs-11">
                  Update
                </th>
                <th width="50" align="center" className="text-center fs-11">
                  Delete
                </th>
                <th width="50" align="center" className="text-center fs-11">
                  Print
                </th>
                <th width="50" align="center" className="text-center fs-11">
                  Export
                </th>
              </tr>
            </thead>
            <tbody>{dataList.map((items, i) => rolesUnderGroup(items))}</tbody>
          </table>

          <Row className="mt-3">
            <Col md={12}>
              <div className="text-end">
                <a
                  href="javascript:;"
                  className="me-3 text-decoration-underline"
                  onClick={(e) => props.onHide && props.onHide()}
                >
                  Cancel
                </a>
                <Button
                  type="submit"
                  variant="contained"
                  startIcon={<CheckIcon />}
                  size="small"
                >
                  Update Permissions
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Spin>
    </>
  );
};
const UserPermissionModal = (props) => {
  return (
    <>
      <PsModalWindow size="lg" title="Role Permissions" {...props}>
        {props.show && <UserPermissionModalComponent {...props} />}
      </PsModalWindow>
    </>
  );
};
export default UserPermissionModal;
